import { createSelector, createSlice } from "@reduxjs/toolkit";
import { sortDataBy } from "../../../SharedModule/utils/dataSort";
import { createChangeOrderReducer } from "../../../SharedModule/utils/changeOrderReducer";
import { TimeConfirmationUser } from "../../types/times-module-types";

type TimeConfirmationState = {
  isLoading: boolean;
  timeConfirmationUsersList: any[] | null;
  orderedBy: {
    orderBy: string;
    criteria: "asc" | "desc";
    dataType?: "string" | "date" | "number";
  };
};

const initialState: TimeConfirmationState = {
  isLoading: true,
  timeConfirmationUsersList: [],
  orderedBy: {
    orderBy: "userName",
    criteria: "asc",
    dataType: "string",
  },
};

export const timeConfirmationResultSlice = createSlice({
  name: "timeConfirmationResult",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    loadTimeConfirmationInfo: (state, action) => {
      state.timeConfirmationUsersList = action.payload;
      state.timeConfirmationUsersList?.forEach((user: TimeConfirmationUser) => {
        user.difference = user.workedHours - user.expectedHours;
      });
      state.isLoading = false;
    },
    changeOrder: createChangeOrderReducer("orderedBy"),
  },
});

// Action creators are generated for each case reducer function
export const { setLoading, loadTimeConfirmationInfo, changeOrder } =
  timeConfirmationResultSlice.actions;

// Selectors
export const IsLoading = (state: any) => {
  return state.timeConfirmationResult.isLoading;
};

export const SelectTimeConfirmationUsersList = ({
  timeConfirmationResult,
}: {
  timeConfirmationResult: TimeConfirmationState;
}) => {
  return {
    timeConfirmationUsersList: timeConfirmationResult.timeConfirmationUsersList,
  };
};

export const SelectOrderCriteria = ({
  timeConfirmationResult,
}: {
  timeConfirmationResult: TimeConfirmationState;
}) => timeConfirmationResult.orderedBy;

export const SelectOrderedBy = createSelector(
  [SelectTimeConfirmationUsersList, SelectOrderCriteria],
  (timeConfirmationResult, orderCriteria) => {
    return {
      timeConfirmationUsersList:
        (timeConfirmationResult.timeConfirmationUsersList &&
          timeConfirmationResult.timeConfirmationUsersList.length > 0 &&
          sortDataBy(
            timeConfirmationResult.timeConfirmationUsersList,
            orderCriteria.orderBy,
            orderCriteria.criteria,
            orderCriteria.dataType
          )) ||
        null,
    };
  }
);

export default timeConfirmationResultSlice.reducer;
